import React from 'react';
import './Loading.css';

export function Loading({ message = 'Loading...', fullScreen = false }) {
  const containerClass = fullScreen ? 'loading-container-fullscreen' : 'loading-container';

  return (
    <div className={containerClass}>
      <div className="loading-spinner"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
}




